import React from "react";
import PropTypes from "prop-types";
import { Box, HStack, Pressable, Text, VStack } from "native-base";
import Modal from "../modal";
import colors from "../../constants/colors";

function UnitsModal(props) {
  const { isOpen, onRequestClose, maximumUnits, onRequestUnits, isSaving } =
    props;

  return (
    <Modal maxWidth={600} isOpen={isOpen} onRequestClose={onRequestClose}>
      <VStack padding={5} space={5}>
        <Text textAlign="center">
          Solo puedes seleccionar máximo {maximumUnits} unidades
        </Text>
        <HStack space={5}>
          <Pressable onPress={onRequestClose} flex={1} disabled={isSaving}>
            <Box
              backgroundColor={colors.primary}
              paddingY={2}
              paddingX={8}
              borderRadius="full">
              <Text color={colors.white} textAlign="center">
                Cerrar
              </Text>
            </Box>
          </Pressable>
          <Pressable onPress={onRequestUnits} flex={1} disabled={isSaving}>
            <Box
              backgroundColor={colors.primary}
              paddingY={2}
              paddingX={8}
              borderRadius="full">
              <Text color={colors.white} textAlign="center">
                Solicitar más unidades
              </Text>
            </Box>
          </Pressable>
        </HStack>
      </VStack>
    </Modal>
  );
}

UnitsModal.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func,
  maximumUnits: PropTypes.number,
  onRequestUnits: PropTypes.func,
  isSaving: PropTypes.bool,
};

UnitsModal.defaultProps = {
  isOpen: false,
  maximumUnits: 0,
  isSaving: false,
};

export default UnitsModal;
